import React, { useEffect, useMemo, useState, useRef } from 'react';
import { EditTable } from '@components';
import { WaterfallGridColumns } from '@model/sectionWidget.model';
import actions from '@flux/action';
import { useDispatch } from 'react-redux';
import { Form, Radio } from 'antd';
import { deepCopy } from '@utils/common';
import './index.scss';

export const addShowCurrencyOnValueCol =
  (_isEditable, _initialShowCurrency, setShowCurrency) => (c) => {
    if (c.dataIndex !== 'value') {
      return c;
    }

    if (!_isEditable) {
      return {
        ...c,
        render: (text, record, index) => {
          if (_initialShowCurrency) {
            return c.render(text, record, index);
          }
          return text;
        },
      };
    }

    return {
      ...c,
      title: () => (
        <div className="header-cell-with-checkbox">
          {/* <Form.Item
            {...props}
            name="showCurrency"
            // initialValue={_initialShowCurrency}
          > */}
          <Radio.Group
            defaultValue={_initialShowCurrency}
            onChange={(e) => {
              setShowCurrency(e.target.value);
            }}
          >
            <Radio value={false}>Hide Currency</Radio>
            <Radio value={true}>Show as Currency</Radio>
          </Radio.Group>
          {/* </Form.Item> */}
        </div>
      ),
    };
  };

export const resetCurrecyState = (_ref, initialShowCurrency) => {
  if (!_ref?.current?.setFieldsValue || !_ref?.current?.setFieldsValue) {
    return;
  }
  const fieldsValue = deepCopy(_ref.current.getFieldsValue());
  _ref.current.setFieldsValue({
    ...fieldsValue,
    showCurrency: initialShowCurrency,
  });
};

export default function WaterfallGrid({
  editTableRef,
  isEditMode,
  sourceData,
  handleSave,
  toggleEdit,
  link,
  afterCancel,
}) {
  const dispatch = useDispatch();

  const initialShowCurrency =
    (sourceData && sourceData[0] && sourceData[0].showCurrency) || false;
  // const initialShowCurrency = sourceData.some((row) => row.showCurrency);
  const [showCurrency, setShowCurrency] = useState(
    (sourceData && sourceData[0] && sourceData[0].showCurrency) || false,
  );
  const showCurrencyRef = useRef(showCurrency);

  useEffect(() => {
    showCurrencyRef.current = showCurrency;
  }, [showCurrency]);

  const orgHandleSave = (data) => {
    dispatch(actions.changeWidget({ widgetId: link, data: {} }));
    if (data[0]) {
      data[0].showCurrency = showCurrencyRef.current;
    }
    handleSave(data);
  };

  const setSumResultAttri = (data) => {
    let currentSum = 0;
    let total = 0;
    data.forEach((x, i) => {
      if (i === 0) {
        x.isFirst = true;
        x.l2 = 'Adjustment';
      }
      if (x.l2 === 'Sum') {
        x.sumResult = currentSum;
        x.value = currentSum;
        currentSum = 0;
        if (i === data.length - 1) {
          x.sumResult = total;
          x.value = parseFloat(total.toPrecision(12));
        }
        return;
      }
      currentSum = Number(currentSum) + Number(x.value);
      total = Number(total) + Number(x.value);
    });
  };

  const onDataChange = (data) => {
    if (!Array.isArray(data)) {
      return;
    }
    setSumResultAttri(data);
  };

  useEffect(() => onDataChange(sourceData), [sourceData]);

  const editTableParams = useMemo(
    () => ({
      isEditMode,
      tableProps: {
        pagination: false,
        rowKey: 'id',
      },
      tableColumns: WaterfallGridColumns.filter((item) =>
        isEditMode ? true : item.dataIndex !== 'l2',
      ).map(
        addShowCurrencyOnValueCol(isEditMode, showCurrency, setShowCurrency),
      ),
      defaultDataSource: sourceData,
      dataChange: onDataChange,
      saveData: orgHandleSave,
      afterCancel: () => {
        resetCurrecyState(editTableRef, initialShowCurrency);
        if (typeof afterCancel === 'function') {
          afterCancel();
        }
      },
      toggleEdit,
    }),
    [isEditMode, JSON.stringify(sourceData), initialShowCurrency],
  );

  return (
    <div
      className={
        showCurrency ? 'show-currency-wrapper' : 'hide-currency-wrapper'
      }
    >
      <EditTable ref={editTableRef} {...editTableParams} />
    </div>
  );
}
